module.exports = __webpack_public_path__ + "img/zhangyis.56f81311.png";